
















































import { LayoutModule } from "@/store/layout";
import { Component, Vue, Watch } from "vue-property-decorator";
import TableActions from "@/components/TableActions.vue";
import AdUnitsAPI from "@/services/adUnits";
import AdUnit from "@/models/adUnit";
import { Meta, QueryParams } from "@/models/general";
import { get } from "lodash";

@Component({
  components: { TableActions },
})
export default class AdUnits extends Vue {
  headers = [
    {
      text: this.$t("ad_units.model.ref"),
      value: "ref",
    },
    {
      text: this.$t("ad_units.model.name"),
      value: "name",
    },
    {
      text: this.$t("ad_units.model.definition_values"),
      value: "definitionValues",
    },
    {
      text: "",
      value: "actions",
    },
  ];

  records: AdUnit[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;
  searchQuery = "";

  created(): void {
    this.getRecords();
  }

  async getRecords(): Promise<void> {
    this.loading = true;
    try {
      const params: QueryParams = {
        page: {
          number: this.meta.pagination.current,
          size: this.meta.pagination.size,
        },
      };

      this.searchQuery && this.searchQuery !== ""
        ? (params.search = this.searchQuery)
        : null;

      const r = await AdUnitsAPI.list(params);
      this.records = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  editRecord(id: string): void {
    this.$router.push({ name: "editAdUnit", params: { id } });
  }

  deleteRecord(id: string): void {
    LayoutModule.setDialogTitle("ad_units.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await AdUnitsAPI.delete(id);
        await this.getRecords();
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getRecords();
  }

  @Watch("searchQuery")
  async search(): Promise<void> {
    this.getRecords();
  }
}
